import Loadable from '../../components/loadable';

const HiitAttendanceReport = Loadable({
  loader: () => import('../../pages/reports/hiit_attendance_report/hiit_attendance_report'),
});

angular.module('gym').value('HiitAttendanceReport', HiitAttendanceReport);
